import React, { useState, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'
import AppLayout from '../components/AppLayout'
import { useAuth } from '../contexts/AuthContext'
import { supabase, ugandaDate } from '../lib/supabase'

export default function DashboardStaff() {
  const { profile, user } = useAuth()
  const [tasks, setTasks] = useState([])
  const [loading, setLoading] = useState(true)
  const navigate = useNavigate()

  useEffect(() => { loadData() }, [])

  const loadData = async () => {
    setLoading(true)
    const today = ugandaDate()
    const { data } = await supabase.from('tasks').select('*')
      .eq('assigned_to', user?.id)
      .in('status', ['Pending', 'In Progress'])
      .order('due_date')
    setTasks(data || [])
    setLoading(false)
  }

  const todayTasks = tasks.filter(t => t.due_date === ugandaDate())
  const overdueTasks = tasks.filter(t => t.due_date < ugandaDate())

  return (
    <AppLayout title="My Dashboard">
      <div style={{ padding: '24px 24px 40px', maxWidth: 600 }}>
        <div style={{ marginBottom: 20 }}>
          <h2 style={{ fontFamily: "'Cormorant Garamond',serif", fontSize: '1.4rem', color: 'var(--green-deep)', marginBottom: 2 }}>
            Good {new Date().getHours() < 12 ? 'morning' : 'afternoon'}, {profile?.full_name?.split(' ')[0]} 👋
          </h2>
          <p style={{ color: 'var(--text-muted)', fontSize: '0.82rem' }}>
            {todayTasks.length > 0 ? `You have ${todayTasks.length} task${todayTasks.length > 1 ? 's' : ''} due today.` : 'No tasks due today.'}
            {overdueTasks.length > 0 ? ` ${overdueTasks.length} overdue.` : ''}
          </p>
        </div>

        {/* Quick Actions */}
        <div className="card" style={{ marginBottom: 16 }}>
          <div className="card-title" style={{ marginBottom: 12 }}>⚡ Quick Actions</div>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(2, 1fr)', gap: 10 }}>
            {[
              { icon: '🌱', label: 'Log Farm Activity', to: '/farm-log' },
              { icon: '🌾', label: 'Record Harvest', to: '/harvest' },
              { icon: '⏱️', label: 'Submit Timesheet', to: '/timesheets' },
              { icon: '🚨', label: 'Report Incident', to: '/incidents' },
              { icon: '🔬', label: 'Quality Check', to: '/quality' },
              { icon: '🪪', label: 'Visitor Log', to: '/visitors' },
            ].map(a => (
              <button key={a.to} onClick={() => navigate(a.to)} style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '12px 14px', background: 'var(--cream)', border: '1px solid var(--border)', borderRadius: 8, cursor: 'pointer', fontSize: '0.82rem', fontWeight: 500 }}
                onMouseEnter={e => e.currentTarget.style.background = 'var(--green-pale)'}
                onMouseLeave={e => e.currentTarget.style.background = 'var(--cream)'}
              >
                <span style={{ fontSize: '1.2rem' }}>{a.icon}</span>
                {a.label}
              </button>
            ))}
          </div>
        </div>

        {/* My Tasks */}
        <div className="card">
          <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12 }}>
            <div className="card-title">✅ My Tasks</div>
            <button className="btn btn-secondary btn-sm" onClick={() => navigate('/tasks')}>View All</button>
          </div>
          {loading ? <div style={{ textAlign: 'center', padding: 20 }}><span className="spinner dark" /></div>
          : tasks.length === 0 ? (
            <div style={{ color: 'var(--text-muted)', fontSize: '0.82rem', padding: '20px 0', textAlign: 'center' }}>
              ✅ No open tasks assigned to you
            </div>
          ) : tasks.map(t => (
            <div key={t.id} style={{ padding: '10px 0', borderBottom: '1px solid var(--border)', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <div>
                <div style={{ fontWeight: 600, fontSize: '0.85rem' }}>{t.title}</div>
                <div style={{ fontSize: '0.72rem', color: t.due_date < ugandaDate() ? 'var(--red)' : 'var(--text-muted)', marginTop: 2 }}>
                  {t.due_date < ugandaDate() ? '⚠️ Overdue — ' : ''}Due {t.due_date}
                </div>
              </div>
              <span className={`badge ${t.status === 'In Progress' ? 'badge-blue' : t.due_date < ugandaDate() ? 'badge-red' : 'badge-amber'}`} style={{ fontSize: '0.62rem' }}>
                {t.status}
              </span>
            </div>
          ))}
        </div>
      </div>
    </AppLayout>
  )
}
